
/**
* 配置文件
*/

const CNF = {
    'api': process.env.REACT_APP_API,
    'authApi': process.env.REACT_APP_AUTH_API,
    'tlerApi': process.env.REACT_APP_TLER_API,
    'cfmsApi': process.env.REACT_APP_CFMS_API,
    'ossApi': process.env.REACT_APP_OSS_API,
    'projectCode': 'SEAL',                        // 项目代码
    'projectName': '用户',                         // 项目名称
    'projectFullname': '用户信息管理系统',           // 项目全称
    'version': '4.0.0',                           // 项目版本   
    'mainUrl': '',                                // 主页地址
    'homeUrl': process.env.REACT_APP_HOME_URL,
    'loginUrl': process.env.REACT_APP_LOGIN_URL,  // 登录地址
    'userUrl': '/users/security',                 // 设置地址
    'locale': 'zhCN',                             // antd国际化语言
    'bassicColor': '#001529',                     // 基础颜色
    'safetyColor': '#308014',                     // 安全颜色
    'warningColor': '#FAAD13',                    // 警告颜色
    'dangerColor': '#FF0000',                     // 危险颜色
    'themeColors': [    //可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
        // '#2f54eb'
    ],
    'isDisplayTableBorder': 0,                         // 是否显示表格边框
    'cookies': {
        'keySecure': true,
        'keyPath': '/',
        'keyDomain': process.env.REACT_APP_COOKIE_DOMAIN,
        'keyExpire': 2592000,
        'keyUid': 'login_xzt_uid',
        'keyId': 'login_xzt_id',
        'keyToken': 'login_xzt_token',
        'keyUsername': 'login_xzt_username',
        'keyDisplayname': 'login_xzt_displayname',
        'keyAvatarUrl': 'login_xzt_avatar_url',
        'keyThemeColor': 'login_xzt_theme_color',
        'keyIsDisplayTableBorder': 'login_xzt_is_display_table_border',
    },
    'timeout': 5000,
    'tDivisor': 9999999999,
    'maxAge': 3600,
    'fontSize': 14,                          // 字体大小
    'menuHeight': '44px',
    'menuLineHeight': '40px',
    'messageDuration': 1.5,                  // 消息弹框持续时间，单位秒
    'animateDuration': 2000,                 // 动画持续时间，单位秒
    'screenWidth': 1440,                     // 系统屏幕宽度
    'searchMarginLeft': 5,                   // 搜索栏左边距
    'rowMarginTop': 10,                      // 行距顶部高度
    'lineHeight': 2.2,                       // 行高
    'tableOperationColumnWidth': 80,         // 表格操作者列宽度
    'tableStatusColumnWidth': 80,            // 表格状态列宽度
    'tableCreateTimeColumnWidth': 120,       // 表格创建时间列宽度
    'tableCreateDisplayeColumnWidth': 90,    // 表格创建者列宽度
    'pageSize': 10,
    'DPL': 2,                                // 小数点长度（Decimal Point Length）
    'swatches': {   // 色板
        'default': ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    'currentSwatche': 'default', // 当前色板
    'status': [ // 状态
        { 'key': '激活', 'value': '激活' },
        { 'key': '禁用', 'value': '禁用' }
    ],
    'navItems': [   // 导航菜单
        {
            'url': '/org/infos', 'icon': 'UserOutlined', 'm': 1, 'name': '组织管理', 'ptn': 'btn_seal_org', 'sub': 'sub1', 'submenu': [
                { 'url': '/org/infos', 'name': '组织信息管理', 'icon': '', 'm': 11, 'ptn': 'btn_seal_org_info', 'isLogModule': true },
                { 'url': '/org/structures', 'name': '组织架构管理', 'icon': '', 'm': 12, 'ptn': 'btn_seal_org_structure', 'isLogModule': true },
                { 'url': '/org/structureGraph', 'name': '组织架构总图', 'icon': '', 'm': 13, 'ptn': 'btn_seal_org_structure', 'isLogModule': false },
                { 'url': '/org/apikeys', 'name': '组织秘钥管理', 'icon': '', 'm': 14, 'ptn': 'btn_seal_org_apikey', 'isLogModule': true },
            ]
        },
        {
            'url': '/users', 'icon': 'UserOutlined', 'm': 2, 'name': '用户管理', 'ptn': 'btn_seal_user', 'sub': 'sub2', 'submenu': [
                { 'url': '/users', 'name': '用户信息管理', 'icon': '', 'm': 21, 'ptn': 'btn_seal_user', 'isLogModule': true },
                { 'url': '/user/infos', 'name': '员工信息管理', 'icon': '', 'm': 22, 'ptn': 'btn_seal_user_info', 'isLogModule': false },
            ]
        },
        { 'url': '/groups', 'icon': 'TeamOutlined', 'm': 3, 'name': '团队管理', 'ptn': 'btn_seal_group', 'sub': 'sub3', 'submenu': '', 'isLogModule': true },
        { 'url': '/roles', 'icon': 'TrademarkOutlined', 'm': 4, 'name': '角色管理', 'ptn': 'btn_seal_role', 'sub': 'sub4', 'submenu': '', 'isLogModule': true },
        { 'url': '/authoritys', 'icon': 'DeploymentUnitOutlined', 'm': 5, 'name': '权限管理', 'ptn': 'btn_seal_authority', 'sub': 'sub5', 'submenu': '', 'isLogModule': true },
        {
            'url': '/reports', 'icon': 'message', 'm': 6, 'name': '统计报表', 'ptn': 'btn_seal_report', 'sub': 'sub6', 'submenu': [
                { 'url': '/reports/user/utacd', 'name': '每日用户活跃统计', 'icon': '', 'm': 61, 'ptn': 'btn_seal_report_user_utacd', 'isLogModule': false },
                { 'url': '/reports/user/udatc', 'name': '能力类型分类占比', 'icon': '', 'm': 62, 'ptn': 'btn_seal_report_user_udatc', 'isLogModule': false },
                { 'url': '/reports/user/udebc', 'name': '学历类型分类占比', 'icon': '', 'm': 63, 'ptn': 'btn_seal_report_user_udebc', 'isLogModule': false },
                { 'url': '/reports/user/udsxc', 'name': '男女性别分类占比', 'icon': '', 'm': 64, 'ptn': 'btn_seal_report_user_udsxc', 'isLogModule': false },
                { 'url': '/reports/user/utecy', 'name': '年度入职人数趋势', 'icon': '', 'm': 65, 'ptn': 'btn_seal_report_user_utecy', 'isLogModule': false },
                { 'url': '/reports/user/udbcy', 'name': '年龄区间分类占比', 'icon': '', 'm': 66, 'ptn': 'btn_seal_report_user_udbcy', 'isLogModule': false },
            ]
        },
        {
            'url': '/logs', 'icon': 'MessageOutlined', 'm': 7, 'name': '日志管理', 'ptn': 'btn_seal_log', 'sub': 'sub7', 'submenu': [
                { 'url': '/log/operations', 'name': '操作日志管理', 'icon': '', 'm': 71, 'ptn': 'btn_seal_log_operation', 'isLogModule': false },
                { 'url': '/log/logins', 'name': '登录日志管理', 'icon': '', 'm': 72, 'ptn': 'btn_seal_log_login', 'isLogModule': false },
            ]
        }
    ],
    'navUserItems': [
        { 'url': '/users/security', 'name': '安全配置', 'icon': '', 'm': 1, 'ptn': 'btn_seal_user_security', 'submenu': '' },
        { 'url': '/users/basicinfo', 'name': '基本信息', 'icon': '', 'm': 2, 'ptn': 'btn_seal_user_basicinfo', 'submenu': '' }
    ],
    'regex': {
        'ulid': /^[0-9A-Z]{26}$/,
        'password': /^[a-zA-Z0-9~!@#$%^&*()-_+=,<.>]{6,20}$/,
        'phone': /^1[3456789]\d{9}$/,
        'email': /^([a-zA-Z]|[0-9])(\w|\\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
        'username': /^[a-zA-Z0-9._-]{4,50}$/,
        'authority_name': /^[a-z]([a-z_]{6,50})$/,
        'rolename': /^[a-zA-Z]([a-zA-Z-]{6,25})$/,
        'groupname': /^[a-zA-Z]([a-zA-Z0-9-_]{6,25})$/,
        'surname': /^[a-z]{2,25}$/,
        'name': /^[a-z]{2,25}$/,
        'verifyCode': /^\d{6}$/,
    },
    'actionName': { // 动作名称
        'CREATE': '新增',
        'UPDATE': '修改',
        'IMPORT': '导入',
        'EXPORT': '导出',
        'ADD': '添加',
        'REMOVE': '移除',
        'SET': '设置',
        'ACTIVE': '激活',
        'DISABLE': '禁用',
        'ACCREDIT': '授权',
        'RESET': '重置',
        'DELETE': '删除',
    },
    'orgFunctionTypes': [
        { 'key': '决策类', 'value': 1 },
        { 'key': '组织类', 'value': 2 },
        { 'key': '岗位类', 'value': 3 }
    ],
    'sexs': [
        { 'key': '男', 'value': '男' },
        { 'key': '女', 'value': '女' }
    ],
    'abilityTypes': [
        { 'key': '研发类', 'value': '研发类' },
        { 'key': '技术类', 'value': '技术类' },
        { 'key': '服务类', 'value': '服务类' },
        { 'key': '其它类', 'value': '其它类' },
    ],
    'eduBackgrounds': [
        { 'key': '小学', 'value': '小学' },
        { 'key': '初中', 'value': '初中' },
        { 'key': '高中', 'value': '高中' },
        { 'key': '中专', 'value': '中专' },
        { 'key': '大专', 'value': '大专' },
        { 'key': '自考本科', 'value': '自考本科' },
        { 'key': '统招本科', 'value': '统招本科' },
        { 'key': '硕士', 'value': '硕士' },
        { 'key': '博士', 'value': '博士' },
        { 'key': '专家', 'value': '专家' },
    ],
}

export default CNF;